import React from 'react';
import {inject, observer} from 'mobx-react';

import './style/';
import E9Header from './E9Header';
import E9NavMenu from './E9NavMenu';

@inject('portalThemeStore')
@observer
class E9ThemeLayout2 extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {portalThemeStore, location} = this.props;
        const {pathname, query} = location;
        portalThemeStore.getTopMenu(pathname, query);
    }

    render() {
        const {portalThemeStore, location} = this.props;
        const {searchParams, themeInfo, frontEndMenu = []} = portalThemeStore;
        const {themeColorType} = themeInfo;
        const colorClassName = themeColorType ? `e9theme-color-${themeColorType}` : '';
        const {query} = location;
        const {hideHeader = query.hideHeader, hideAside = query.hideAside} = searchParams;

        let contentStyle = {};
        if (hideHeader == 'true' && hideAside == 'true') {
            contentStyle = {top: 0};
        } else if (hideHeader == 'true' && hideAside != 'true') {
            contentStyle = {top: 55};
        } else if (hideHeader != 'true' && hideAside == 'true') {
            contentStyle = {top: 55};
        }

        return (
            <div className={`e9theme-layout2-container ${colorClassName}`}>
                {
                    hideHeader == 'true' ? null : (
                        <div className="e9theme-layout2-header">
                            <E9Header {...this.props} />
                        </div>
                    )
                }
                {
                    hideAside == 'true' ? null : (
                        <div className="e9theme-layout2-navbar" style={hideHeader == 'true' ? {top: 0} : {}}>
                            {frontEndMenu && frontEndMenu.length > 0 && <E9NavMenu {...this.props} />}
                        </div>
                    )
                }
                <div className="e9theme-layout2-content" style={contentStyle}>
                    <div id="themeLayoutMask" className="e9theme-layout2-mask"></div>
                    <div className="e9theme-layout2-main" style={hideHeader == 'true' && hideAside == 'true' ? {padding: 0} : {}}>
                        <div id="themeLayoutRoute" className="e9theme-layout2-route">
                            {this.props.children}
                        </div>
                        <div id="themeLayoutFrame" className="e9theme-layout2-frame">
                            <iframe id="mainFrame" name="mainFrame" src="about:blank"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default E9ThemeLayout2;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/layout2/index.js